<div class="mb-3">
  <label *ngIf="label" [ngClass]="{'required': required}" [for]="identifier">{{ label }}</label>
  <input [id]="identifier" type="number" class="form-control"
         [(ngModel)]="value" name="nome" min="0" (blur)="onblur($event)"
         [disabled]="disabled" [required]="required" [maxlength]="maxLength"
         style="height:36px"
         [ngClass]="{ 'is-invalid': form && (form.submitted || form.controls[name]?.touched || form.controls[name]?.dirty) && form.controls[name]?.errors}" />
  <validation-errors [form]="form" [controlName]="name"></validation-errors>
</div>
